import React, { useEffect, useRef, useState } from "react"
import { Document, Page, pdfjs } from "react-pdf"
import { PARENT_PROPERTIES } from "./../utils/constant"

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`

const PdfView = ({
  pdfUrl,
  onLoadSuccess,
  currentPage,
  setCurrentPage,
  numPages,
  jsonContent,
  setHoveredKey, // Add this prop to set the hovered key
  hoveredKey, // Get the hovered key
  colorIndexes,
  fileLoading,
  isFileLocked,
  isValidUser,
}) => {
  const canvasRef = useRef(null)
  const [pdfRendered, setPdfRendered] = useState(false)
  // const [pageDimensions, setPageDimensions] = useState({
  //   width: 850,
  //   height: 0,
  // }) // Track the page dimensions
  const [pageDimensions, setPageDimensions] = useState({ width: 0, height: 0 })
  const [xTotalPageUnits, setXTotalPageUnits] = useState(0)
  const [yTotalPageUnits, setYTotalPageUnits] = useState(0)
  const [pageRotations, setPageRotations] = useState({})
  const dpi = 200 // Set the desired DPI
  const hoveredColor = "rgba(253,255,50, 0.7)"

  // This function is called when a page is successfully rendered
  const onPageRenderSuccess = (page) => {
    setPdfRendered(true) // Set the state to true once the page has been rendered
    const viewport = page.getViewport({ scale: 1.5 })

    const pageWidthInPoints = page.view[2]
    const pageHeightInPoints = page.view[3]

    // Convert points to inches
    const pageWidthInInches = pageWidthInPoints / 72
    const pageHeightInInches = pageHeightInPoints / 72

    // Calculate dimensions in units based on DPI
    const newXTotalPageUnits = pageWidthInInches * dpi
    const newYTotalPageUnits = pageHeightInInches * dpi

    setXTotalPageUnits(newXTotalPageUnits)
    setYTotalPageUnits(newYTotalPageUnits)

    setPageDimensions({
      width: viewport.width,
      height: viewport.height,
    }) // Set the page dimensions
  }

  // Function to draw bounding boxes

  // Effect to draw bounding boxes once the PDF is rendered

  const drawBoundingBoxes = (jsonContent, pageNumber) => {
    const canvas = canvasRef.current

    if (!canvas) return

    const context = canvas?.getContext("2d")
    const container = canvas?.parentElement
    const dpr = window.devicePixelRatio || 1

    const { width, height } = pageDimensions // Assume pageDimensions is provided

    canvas.width = width
    canvas.height = height
    context.clearRect(0, 0, canvas.width, canvas.height)

    let boundingBoxes = []

    if (jsonContent) {
      const entities = PARENT_PROPERTIES

      for (const entityKey in jsonContent.result) {
        if (entities.includes(entityKey)) {
          const entity = jsonContent.result[entityKey]

          // If it's an array (like "Order_Service_HCPCS_CPT_Code" or "Order_Service_Diagnosis_Code")
          if (Array.isArray(entity)) {
            let i = 0

            entity.forEach((item) => {
              for (const key in item) {
                const field = item[key]
                // Check if there's a bounding box and page number for the current field
                const pgNumber = field.page_number || 1

                if (pgNumber === pageNumber && field.bounding_box) {
                  let {
                    top_left_x,
                    top_left_y,
                    bottom_right_x,
                    bottom_right_y,
                  } = field.bounding_box

                  // Calculate width and height in terms of the 200 dpi units
                  const divWidthInUnits = bottom_right_x - top_left_x
                  const divHeightInUnits = bottom_right_y - top_left_y

                  // Convert bounding box coordinates from page units to percentages
                  const cssLeftPercentage =
                    (top_left_x / xTotalPageUnits) * width
                  const cssTopPercentage =
                    (top_left_y / yTotalPageUnits) * height

                  // Convert width and height from page units to pixel values
                  const divWidthInPx =
                    (divWidthInUnits / xTotalPageUnits) * width
                  const divHeightInPx =
                    (divHeightInUnits / yTotalPageUnits) * height

                  // Draw the bounding box on the canvas

                  //For colorMapping
                  const fieldKeyI = `${entityKey}:${key}:${i}`

                  context.lineWidth = 2
                  context.fillStyle =
                    `${fieldKeyI}` === hoveredKey ? hoveredColor : "transparent"
                  context.strokeStyle =
                    `${fieldKeyI}` === hoveredKey
                      ? hoveredColor
                      : colorIndexes[fieldKeyI]

                  context.fillRect(
                    Math.round(cssLeftPercentage),
                    Math.round(cssTopPercentage),
                    Math.round(divWidthInPx),
                    Math.round(divHeightInPx)
                  )

                  context.strokeRect(
                    Math.round(cssLeftPercentage),
                    Math.round(cssTopPercentage),
                    Math.round(divWidthInPx),
                    Math.round(divHeightInPx)
                  )

                  boundingBoxes.push({
                    key: `${fieldKeyI}`,
                    left: cssLeftPercentage,
                    top: cssTopPercentage,
                    right: cssLeftPercentage + divWidthInPx,
                    bottom: cssTopPercentage + divHeightInPx,
                  })
                }
                i++
              }
            })
          } else {
            // Handling for non-array entities
            for (const key in entity) {
              const pgNumber = entity[key].page_number || 1

              if (pgNumber === pageNumber && entity[key]?.bounding_box) {
                let { top_left_x, top_left_y, bottom_right_x, bottom_right_y } =
                  entity[key]?.bounding_box || {}

                // If there's a bounding box for this specific key, overwrite the values
                if (entity[key]?.bounding_box[key]) {
                  ;({ top_left_x, top_left_y, bottom_right_x, bottom_right_y } =
                    entity[key]?.bounding_box[key])
                }

                // Calculate width and height in terms of the 200 dpi units
                const divWidthInUnits = bottom_right_x - top_left_x
                const divHeightInUnits = bottom_right_y - top_left_y

                // Convert bounding box coordinates from page units to percentages
                const cssLeftPercentage = (top_left_x / xTotalPageUnits) * width
                const cssTopPercentage = (top_left_y / yTotalPageUnits) * height

                // Convert width and height from page units to pixel values
                const divWidthInPx = (divWidthInUnits / xTotalPageUnits) * width
                const divHeightInPx =
                  (divHeightInUnits / yTotalPageUnits) * height

                // Draw the bounding box on the canvas
                context.lineWidth = 2

                //For colorMapping
                const fieldKeyI = `${entityKey}:${key}`

                let keyToCheck = `${entityKey}:${key}`
                context.fillStyle =
                  keyToCheck === hoveredKey ? hoveredColor : "transparent"
                context.strokeStyle =
                  keyToCheck === hoveredKey
                    ? hoveredColor
                    : colorIndexes[fieldKeyI]

                context.fillRect(
                  Math.round(cssLeftPercentage),
                  Math.round(cssTopPercentage),
                  Math.round(divWidthInPx),
                  Math.round(divHeightInPx)
                )

                context.strokeRect(
                  Math.round(cssLeftPercentage),
                  Math.round(cssTopPercentage),
                  Math.round(divWidthInPx),
                  Math.round(divHeightInPx)
                )

                boundingBoxes.push({
                  key: keyToCheck,
                  left: cssLeftPercentage,
                  top: cssTopPercentage,
                  right: cssLeftPercentage + divWidthInPx,
                  bottom: cssTopPercentage + divHeightInPx,
                })
              }
            }
          }
        }
      }
    }

    // Mouse hover event to highlight bounding boxes
    container.addEventListener("mousemove", (e) => {
      const rect = container.getBoundingClientRect()
      const scrollLeft = container.scrollLeft
      const scrollTop = container.scrollTop
      const mouseX = (e.clientX - rect.left + scrollLeft) * dpr
      const mouseY = (e.clientY - rect.top + scrollTop) * dpr

      let isHovered = false

      for (const box of boundingBoxes) {
        if (
          mouseX > box.left &&
          mouseX < box.right &&
          mouseY > box.top &&
          mouseY < box.bottom
        ) {
          setHoveredKey(box.key)
          isHovered = true
          break
        }
      }

      if (!isHovered) {
        setHoveredKey(null)
      }
    })
  }

  useEffect(() => {
    const isVertical = getIsVerticalFlag()
    if (!isVertical) {
      clearBoundingBoxes()
    }
  }, [pageRotations, hoveredKey, currentPage])

  useEffect(() => {
    const isVertical = getIsVerticalFlag()

    if (pdfRendered && jsonContent && isVertical) {
      drawBoundingBoxes(jsonContent, currentPage)
    }
  }, [
    pdfRendered,
    jsonContent,
    currentPage,
    setHoveredKey,
    hoveredKey,
    pageDimensions,
    colorIndexes,
    xTotalPageUnits,
    yTotalPageUnits,
    pageRotations,
  ])

  const getIsVerticalFlag = () => {
    const pageRotation = pageRotations[currentPage] || 0 // Default to 0 if not rotated

    return pageRotation === 0
  }

  const clearBoundingBoxes = () => {
    const canvas = canvasRef.current
    if (canvas) {
      const ctx = canvas.getContext("2d")
      ctx.clearRect(0, 0, canvas.width, canvas.height) // Clears the entire canvas
    }
  }

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1)
    }
  }

  const handleNextPage = () => {
    if (currentPage < numPages) {
      setCurrentPage(currentPage + 1)
    }
  }

  // Load the PDF and set the page width based on the container size
  const handleLoadSuccess = (data) => {
    onLoadSuccess(data) // Call the provided onLoadSuccess function
  }

  const handleRotate = (pageNumber) => {
    setPageRotations((prev) => {
      const newRotation = ((prev[pageNumber] || 0) + 180) % 360 // Reset to 0 after 270°
      return {
        ...prev,
        [pageNumber]: newRotation,
      }
    })
  }

  const getRotationIcon = () => {
    switch (pageRotations[currentPage] || 0) {
      case 0:
        return <>⬆️</> // 0°
      case 90:
        return <>➡️</> // 90°
      case 180:
        return <>⬇️</> // 180°
      case 270:
        return <>⬅️</> // 270°
      default:
        return <>⬆️</> // Default to 0°
    }
  }

  if (fileLoading || !onLoadSuccess) {
    return (
      <div className="document-view">
        <div className="loading-container">
          <div className="loading-message">Loading...</div>
        </div>
      </div>
    )
  }

  if (isFileLocked) {
    return (
      <div className="document-view">
        <div className="display-center-p">
          <p
            style={{
              color: "green",
              fontSize: "48px",
              margin: "0px",
            }}
          >
            🔒
          </p>{" "}
          <p>
            File has been locked recently, please select other file from the
            list
          </p>
        </div>
      </div>
    )
  }

  if (!isValidUser) {
    return (
      <div className="document-view">
        <div className="display-center-p">
          <p
            style={{
              color: "green",
              fontSize: "48px",
              margin: "0px",
            }}
          >
            🚫
          </p>{" "}
          <p>Invalid User / No files available</p>
        </div>
      </div>
    )
  }

  return (
    <div className="document-view">
      {pdfUrl ? (
        <>
          <div
            className="navigation"
            // style={
            //   process.env.REACT_APP_ENV === "test"
            //     ? { backgroundColor: "#ffb6c187" }
            //     : {}
            // }
          >
            <button onClick={handlePreviousPage} disabled={currentPage === 1}>
              Previous
            </button>
            <p>
              Page {currentPage} of {numPages}
            </p>
            <button
              onClick={handleNextPage}
              disabled={currentPage === numPages}
            >
              Next
            </button>
          </div>
          <div className="document-container">
            <Document file={pdfUrl} onLoadSuccess={handleLoadSuccess}>
              <Page
                pageNumber={currentPage}
                onLoadSuccess={onPageRenderSuccess}
                width={pageDimensions.width}
                rotate={pageRotations[currentPage] || 0}
              />
            </Document>
            <canvas className="document-canvas" ref={canvasRef} />
          </div>

          <div
            onClick={() => handleRotate(currentPage)}
            className="rotation-icon"
            title="Click to Rotate"
          >
            {getRotationIcon()}
          </div>
        </>
      ) : (
        <div className="display-center-p">
          <p
            style={{
              color: "green",
              fontSize: "48px",
              margin: "0px",
            }}
          >
            📄
          </p>{" "}
          <p>Please select a document from list</p>
        </div>
      )}
    </div>
  )
}

export default PdfView
